import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CategoryWithDimensionId,
  DimensionsDrawerMode,
} from "@/store/dimensions/utils/types/common";
import { isCategoryWithDimensionId } from "@/components/pages/dimensions/utils/helpers/isCategoryWithDimensionId";
import { setDimensionsState } from "@/store/dimensions/dimensionsSlice";
import { generateDimensionCategoriesFromCategoriesWithCosts } from "@/components/pages/dimensions/utils/helpers/generateDimensionCategoriesFromCategoriesWithCosts";
import { RootState } from "@/store/store";
import { categoriesByDimensionIdMapSelector } from "@/store/dimensions/selectors/dimensions-data/categoriesByDimensionIdMapSelector";
import { DimensionWithCosts } from "@/services/cloudchipr.api";

export const editDimensionOrCategoryThunk = createAsyncThunk(
  "dimensions/editDimensionOrCategory",
  (
    dimensionOrCategory: DimensionWithCosts | CategoryWithDimensionId,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;
    const isCategory = isCategoryWithDimensionId(dimensionOrCategory);

    const categories = isCategory
      ? categoriesByDimensionIdMapSelector(state)?.[
          dimensionOrCategory.dimensionId
        ]
      : dimensionOrCategory.categories;

    const newState = isCategory
      ? {
          dimensionId: dimensionOrCategory.dimensionId,
          drawerMode: "categoryEdit" as DimensionsDrawerMode,
          dimensionName: "",
          editingCategoryId: dimensionOrCategory.id,
        }
      : {
          drawerMode: "dimensionEdit" as DimensionsDrawerMode,
          dimensionId: dimensionOrCategory.id,
          dimensionName: dimensionOrCategory.name,
        };

    dispatch(
      setDimensionsState({
        ...newState,
        sharedCosts: [],
        categories: generateDimensionCategoriesFromCategoriesWithCosts(
          categories ?? [],
        ),
      }),
    );
  },
);
